<template>
  <div class="container">
    <div class="top-content">
      <div class="query">
        <div>
          <el-button size="small" type="primary" plain @click="addData">新增</el-button>
        </div>
        <div style="display: flex;align-items: center">
          <span>标题：</span>
          <el-input style="width: 200px" size="small" v-model="formData.title" placeholder="请输入标题"></el-input>
          <span style="margin-left: 10px;">开始时间：</span>
          <el-date-picker style="width: 200px" size="small" v-model="formData.startTime" type="date" placeholder="开始时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          <span style="margin-left: 10px;">结束时间：</span>
          <el-date-picker style="width: 200px" size="small" v-model="formData.endTime" type="date" placeholder="结束时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          <el-button style="margin-left: 10px" size="small" type="primary" plain>查询</el-button>
        </div>
      </div>
      <el-table ref="setCurrentRow" v-loading="loading" height="calc(100% - 75px)" :data="tableData" border stripe size="small" :header-cell-style="{background:'#ECF5FF',color:'#606266',fontWeight:'bold',align:'center'}" highlight-current-row>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column width="350px" prop="title" label="标题"  header-align="center" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sendUser" label="发送人" header-align="center" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDate" label="发送日期" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column width="200px" label="操作" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button size="small" type="primary" plain icon="el-icon-edit" circle @click="editData(scope.row)"></el-button>
            <el-button size="small" type="danger" icon="el-icon-delete" circle @click="deleteData(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size.sync="rows"
        :page-sizes="[15, 30, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="background-color: #ecf5ff;">
      </el-pagination>
    </div>
    <div class="bottom-content">
      <org-tree :pid="pid" :horizontal="false" :show="true"></org-tree>
    </div>
    <!-- 弹窗表单 -->
    <el-dialog @close="close" :title="title" :visible.sync="dialogVisible" width="40%">
      <template>
        <el-form ref="verification" label-width="90px" :model="formData" :rules="rules">
          <el-row>
            <el-col :span="24">
              <el-form-item label="名称" prop="title">
                <el-input v-model="formData.title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="发送人" prop="sendUser">
                <el-input v-model="formData.sendUser"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="发送日期" prop="createDate">
                <el-date-picker style="width: 100%" v-model="formData.createDate" type="date" placeholder="开始时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="transmitData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import orgTree from './orgTree'

export default {
  name: "postDuty",
  components:{
    orgTree
  },
  data() {
    return {
      pid:'612137965259264000',
      loading:false,
      tableData:[{
        name:5
      }],
      page:1,
      rows:15,
      total:0,
      name:'',
      title:'添加',
      formData:{},
      dialogVisible:false,
      //表单验证
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        sendUser: [{ required: true, message: "发送人不能为空", trigger: "blur" }],
        createDate: [{ required: true, message: "发送日期不能为空", trigger: "blur" }],
      },
      projectId:'',
      sectId:''
    }
  },
  mounted() {
    let projectInfo = JSON.parse(sessionStorage.getItem("projectInfo"));
    if (!!projectInfo) {
      if (!!projectInfo.projectId) {
        this.projectId = projectInfo.projectId;
      }
      if (!!projectInfo.mainSectionId) {
        this.sectId = projectInfo.mainSectionId;
      }
    }
    this.getTableData()
  },
  methods:{
    // 获取列表
    getTableData() {
      let params = {
        title:this.formData.title,
        startTime:this.formData.startTime,
        endTime:this.formData.endTime,
        projectId:this.projectId,
        sectId:this.sectId,
        orgType:'qualitySafeChart',
        page:this.page,
        rows:this.rows,
      }
      // this.$axios.get(`/api/checkwork/orgDepartmentBase/getAllContentList`,{params:params}).then( res => {
      //   this.tableData = res.data.rows
      //   this.pid = this.tableData[0].id
      //   this.total =res.data.total
      //   this.$nextTick(() => {
      //     if( this.tableData.length > 0){
      //       this.$refs.monthlyPlanTable.setCurrentRow(this.tableData[0])
      //     }
      //   });
      // })
    },
    // 点击行
    rowClick(row) {
      this.pid = row.id
    },
    // 关闭弹窗
    close() {
      this.$refs.verification.resetFields();
    },
    // 新增打开弹窗
    addData() {
      this.dialogVisible = true
    },
    // 编辑
    editData(row) {
      this.formData = JSON.parse(JSON.stringify(row))
      this.title = '编辑'
      this.dialogVisible = true
    },
    // 删除
    deleteData(row) {
      this.$confirm('此操作将永久删除该节点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$axios.delete(`/api/checkwork/orgDepartmentBase/subDelContent?departmentId=${this.basicInfo.id}`).then( res => {
        //   if (res.data.success) {
        //     this.$message({type: 'success', message: '删除成功!'});
        //     this.getTreeData()
        //   } else {
        //     return  this.$message({type: 'warning', message: res.data.message});
        //   }
        // })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消删除'});
      });
    },
    // 保存数据
    transmitData() {
      this.$refs.verification.validate((valid) => {
        if (valid) {
          // this.$axios.post(`/api/checkwork/orgDepartmentBase/mainInsert`,this.$qs.stringify(this.formData)).then( res => {
          //   console.log(res);
          //   if (res.data.success) {
          //     this.dialogVisible = false
          //     this.$message({type: 'success', message: '保存成功!'});
          //     this.getTableData()
          //   } else {
          //     return  this.$message({type: 'warning', message: res.data.message});
          //   }
          // })
        } else {
          return false;
        }
      });
    },
    // 监听 pageSize 改变的事件
    handleSizeChange(newSize) {
      this.rows = newSize;
      this.page = 1
      this.getTableData();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.getTableData();
    },
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.top-content {
  height: 30%;
  border-bottom: 2px solid #e4e7ed;
  box-sizing: border-box;
  padding-bottom: 10px;
}
.bottom-content {
  height: 70%;
  padding: 10px 0;
  box-sizing: border-box;
}
.query {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
  font-size: 12px;
}
/deep/ .el-dialog__body {
  padding: 20px 20px 0px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/orgTree/postDuty.vue